import { ApiModule, type PaginatedResponseData } from '@common/index';
import type { InstructorStatusItem, InstructorStatus } from '../models';

export class InstructorStatusApi extends ApiModule {
  protected endpoint = '/instructor-status';

  public async pageInstructorStatuss(params: any) {
    return this.api.post<PaginatedResponseData<InstructorStatusItem>, any>(
      `${this.endpoint}/page?page=${params.page}&size=${params.itemsPerPage}&sort=${params.sort ?? ''}`,
      {
        ...params
      }
    );
  }

  public loadInstructorStatusDetails(id: number) {
    return this.api.get<InstructorStatus>(`${this.endpoint}?id=${id}`);
  }

  public saveInstructorStatus(params: any) {
    return this.api.post(`${this.endpoint}`, {
      ...params
    });
  }

  public deleteInstructorStatus(id: number) {
    return this.api.delete(`${this.endpoint}?id=${id}`);
  }
  public getList() {
    return this.api.get<InstructorStatus[]>(`${this.endpoint}/list`);
  }
}
